export const CC = 'credit_card';
export const CHECK = 'check';
export const WIRE_TRANSFER = 'wire';
export const CASH = 'cash';
export const EXTERNAL = 'external';
export const GOOGLE_PAY = 'google_pay';
export const APPLE_PAY = 'apple_pay';
export const WALLET_PAYMENT_TYPES = [GOOGLE_PAY, APPLE_PAY];
